// Copyright (C) 2013 Minted Inc.
// All Rights Reserved

/* jshint multistr: true */

M.Template = M.Template || {};
M.Template.Sample = {
  SampleDialog: '\
  <@ if(M.IS_MOBILE_OPTIMIZED || M.IS_MOBILE) { @>\
    <h3><@= productName @></h3> \
    <div class="imageContainer"> \
      <img src="<@= thumbnailUrl @>" /> \
    </div> \
    <div class="sample-notes-block"> \
      <p class="cost-info"> \
        <@ if (promoCode) { @> \
        Free Sample Code: <b><@= promoCode @></b> \
        Copy this code and enter it in checkout to \
        get up to $10 in samples for free. \
        <@ } else { @> \
        Samples are only $<@= sampleCost @> each and we&#39;ll credit \
        you back for the value of your samples \
        when you order wedding invitations. \
        <@ } @> \
      </p> \
      <p class="caption"> \
        <@= disclaimer ? disclaimer : "" @> Samples do not \
        contain personalized text<@ if (isWedding) { @> \
        and custom colors are an additional charge<@ } @>.</p> \
    </div> \
    <div class="paperOptions"> \
      <h4><@= paperChoices.length > 1 ? "Choose " : " " @>Paper</h4> \
      <div class="paper-options-list"> \
        <ul> \
          <@ for (var i = 0; i < paperChoices.length; i++) { @> \
            <li class="paper-option"> \
              <label class="add-sample-dialog__paper-option-container" \
                for="paperChoice-<@= paperChoices[i].id @>"> \
                <input class="paperOption" \
                  <@ if (paperChoices[i].id == selectedPaper.id) { @> \
                    checked="checked" \
                  <@ } @> \
                   type="radio" \
                   name="paper" \
                   value="<@= paperChoices[i].id @>" \
                   id="paperChoice-<@= paperChoices[i].id @>" \
                   style="display:<@= paperChoices.length == 1 ? "none" : "inherit" @>" \
                   /> \
                <img class="check-img" src=""/> \
                <span class="paperName"> \
                  <@= paperChoices[i].name @> \
                </span> \
                <br> \
                <span class="paperDesc"> \
                  <@= paperChoices[i].description @> \
                </span> \
              </label> \
            </li> \
          <@ } @> \
        </ul> \
      </div> \
    </div> \
    <div class="colorOptions"> \
      <h4><@= colorChoices.length > 1 ? "Choose " : " " @>Color</h4> \
      <div class="color-options-list"> \
        <ul> \
          <@ for (var i = 0; i < colorChoices.length; i++) { @> \
            <li class="color-option"> \
              <label class="add-sample-dialog__color-option-container" \
                for="colorChoice-<@= colorChoices[i].id @>"> \
                <input class="colorOption" \
                  <@ if (colorChoices[i].id == selectedColor.id) { @> \
                    checked="checked" \
                  <@ } @> \
                  type="radio" \
                  id="colorChoice-<@= colorChoices[i].id @>" \
                  name="colorChoice" value="<@= colorChoices[i].id @>" \
                 style="display:<@= colorChoices.length == 1 ? "none" : "inherit" @>" \
                  /> \
                <img src="<@= colorChoices[i].thumbnail @>" /> \
              </label> \
            </li> \
          <@ } @> \
        </ul> \
      </div> \
    </div> \
    <@ if (isWedding && shouldShowWeddingSuiteOption) { @> \
      <div class="separator"> \
        <span class="floatL" style="width:90px;text-align:right;"><b>Add to Your Suite</b></span> \
        <div class="floatL" style="width:300px;margin-left:10px;"> \
          <input type="checkbox" name="weddingSuiteOption"></input> \
          <p style="margin-left:0px;width:300px;margin-top:10px;"> \
            Yes! Please send me a matching RSVP card, directions card, and belly band with my samples, <b>FREE</b> with code <b>10FREESAMPLES</b></p> \
        </div> \
      </div> \
    <@ } @> \
    <@ if (isWedding) { @> \
      <div class="wedding-date-options"> \
        <h4>Wedding date</h4> \
        <div class="dialogDatePickerTarget"></div> \
      </div> \
    <@ } @> \
    <div class="button-section"> \
      <button class="button btnNext nextButton">Next</button> \
      <a class="button button-link button-last cancelButton">Cancel</a> \
    </div> \
  <@ } else { @> \
    <div class="separator"> \
      <span class="floatL" style="width:110px;text-align:right;"> \
        <img class="shadowBorder" style="max-width:115px;" \
        src="<@= thumbnailUrl @>" /></span> \
      <span class="floatL" style="width: 300px;margin-left:25px;"> \
        <h6 style="text-transform: uppercase;">order a sample.</h6> \
        <p> \
          <@ if (promoCode) { @> \
          Free Sample Code: <b><@= promoCode @></b></br> \
          Copy this code and enter it in checkout to \
          get up to $10 in samples for free. \
          <@ } else { @> \
          Samples are only <b>$<@= sampleCost @></b> each.</br> \
          If you place an order with us, \
          we will credit your account for your sample purchase. \
          <@ } @> \
        </p> \
        <p class="caption"> \
          <@= disclaimer ? disclaimer : "" @> Please note that samples <b>do not</b>  \
          contain personalized text<@ if (isWedding) { @> \
          and custom colors are an additional charge<@ } @>.</p> \
      </span> \
    </div> \
    <div class="separator paperOptions"> \
      <span class="floatL" style="width:90px;text-align:right;"> \
        <b><@= paperChoices.length > 1 ? "Choose " : " " @>Paper</b> \
      </span> \
      <div class="floatL" style="width:340px;margin-left:10px;"> \
        <ul> \
          <@ for (var i = 0; i < paperChoices.length; i++) { @> \
            <li class="clearFix bm"> \
              <input class="floatL paperOption" \
                <@ if (paperChoices[i].id == selectedPaper.id) { @> \
                  checked="checked" \
                <@ } @> \
                 type="radio" \
                 name="paper" \
                 value="<@= paperChoices[i].id @>" \
                 id="paperChoice-<@= paperChoices[i].id @>" \
                 style="display:<@= paperChoices.length == 1 ? "none" : "inherit" @>" \
                 /> \
              <label class="floatR" for="paperChoice-<@= paperChoices[i].id @>" \
                style="clear:none;text-align:left;display:block;width:310px;"> \
                <span class="type"><strong><@= paperChoices[i].name @> \
                </strong></span>  \
                <span class="paperDesc"> \
                &nbsp;<@= paperChoices[i].description @>&nbsp;</span> \
              </label> \
            </li> \
          <@ } @> \
        </ul> \
      </div> \
    </div> \
    <div class="separator colorOptions"> \
      <span class="floatL" style="width:90px;text-align:right;"> \
        <b><@= colorChoices.length > 1 ? "Choose " : " " @>Color</b> \
      </span> \
      <div class="floatL" style="width:370px;margin-left:10px;"> \
        <ul class="inline"> \
          <@ for (var i = 0; i < colorChoices.length; i++) { @> \
            <li style="margin-right:2px;width:120px;"> \
              <div class="fieldWrapper fieldWrapperRadio"> \
                <input class="floatL colorOption" \
                  <@ if (colorChoices[i].id == selectedColor.id) { @> \
                    checked="checked" \
                  <@ } @> \
                  type="radio" \
                  id="colorChoice-<@= colorChoices[i].id @>" \
                  name="colorChoice" value="<@= colorChoices[i].id @>" \
                 style="display:<@= colorChoices.length == 1 ? "none" : "inherit" @>" \
                  /> \
                <label style="width:auto;" for="colorChoice-<@= colorChoices[i].id @>"> \
                  <img src="<@= colorChoices[i].thumbnail @>" class="floatL" /> \
                </label> \
              </div> \
            </li> \
          <@ } @> \
          <@ if (isWedding && !shouldOnlyShowDefaultColorway) { @> \
            <li style="width:400px;"> \
              <div class="fieldWrapper fieldWrapperRadio"> \
                <input type="radio" name="colorChoice" id="customColorsCheckbox" \
                  value="custom" /> \
                <label for="customColorsCheckbox" style="width:340px"> \
                  <div class="media"> \
                    <div class="img"> \
                      <img src="<@= M.img_src(\'/static/images/sprites/search/color_swatches_sample.png\') @>" /> \
                    </div> \
                    <div class="bd"> \
                      <p> \
                        <b>Custom Colors (+$15)</b><br /> \
                        <span class="caption" style="margin-left:0px;width:300px;"> \
                          We\'ll create a custom sample with the  \
                          color(s) of your choice.<br />Note that the sample will not  \
                          contain personalized text. \
                        <span> \
                      </p> \
                    </div> \
                  </div> \
              </label> \
            </li> \
          <@ } @> \
        </ul> \
      </div> \
    </div> \
    <@ if (isWedding && shouldShowWeddingSuiteOption) { @> \
      <div class="separator"> \
        <span class="floatL" style="width:90px;text-align:right;"><b>Add to Your Suite</b></span> \
        <div class="floatL" style="width:300px;margin-left:10px;"> \
          <input type="checkbox" name="weddingSuiteOption"></input> \
          <p style="margin-left:0px;width:300px;margin-top:10px;"> \
            Yes! Please send me a matching RSVP card, directions card, and belly band with my samples, <b>FREE</b> with code <b>10FREESAMPLES</b></p> \
        </div> \
      </div> \
    <@ } @> \
    <@ if (isWedding) { @> \
      <div class="separator"> \
        <span class="floatL" style="width:90px;text-align:right;"><b>Wedding date</b></span> \
        <div class="floatL weddingDate dialogDatePickerTarget" style="width:300px;margin-left:10px;"> \
        </div> \
      </div> \
    <@ } @> \
    <div> \
      <ul class="buttons inline" style="margin-right:10px;"> \
        <li><a class="nextButton btnNext button primary h30"> \
          <span>next</span> \
          <img class="sprite buttonArrowIcon"  \
            src="/static/images/sprite_placeholder.png" /></a> \
        </li> \
        <li> \
          <a class="cancelButton button h30 cancel"> \
            <span>cancel</span></a> \
        </li> \
      </ul> \
    </div> \
  <@ } @>',

  CustomColors: ' \
    <div class="separator solid"><div class="floatL"> \
      <p><b>Select a color swatch</b></p> \
      <@ for (var i = 0; i < defaultColors.length; i++) { @> \
        <ul class="inline customerColorChoices"> \
          <@ for (var j = 0; j < defaultColors[i].length; j++) { @> \
            <li class="swatchWrap" data-rgb="<@= defaultColors[i][j].rgb @>"> \
              <div class="colorBlock" data-rgb="<@= defaultColors[i][j].rgb @>"  \
                 data-name="<@= defaultColors[i][j].name.toLowerCase() @>"  \
                 style="background-color:#<@= defaultColors[i][j].rgb @>"> \
                  <img class="removeSwatch"  \
                    src="' + M.img_src("/static/images/sprites/core/delete_icon.png") + '" \
                    /> \
                 </div> \
              <div class="colorName"><@= defaultColors[i][j].name.toLowerCase() @></div> \
            </li> \
          <@ } @> \
        </ul> \
      <@ } @> \
      <p><b>Add a custom color</b></p> \
      <ul class="userColors inline floatL"></ul> \
      <img src="/static/images/colorpicker/btn_plus.png" class="addCustomColor floatL" /> \
    </div> \
    <div class="floatR"> \
      <p><b>Leave us instructions</b></p> \
      <textarea> \
        <@ if (instructions) { @> \
          <@= instructions @>  \
        <@ } else { @> \
          <@= defaultInstructions @>  \
        <@ } @> \
      </textarea> \
      <p><a class="seeYourPalette">See your palette</a></p> \
    </div></div> \
    <ul class="buttons"> \
      <li><a class="saveButton button primary h30">add to cart</a></li> \
      <li><a class="cancelButton button h30 cancel">cancel</a></li> \
    </ul>',

  ColorChoice: '\
    <@ if (isCustomColor) { @> \
      <p><b>Describe your custom color.</b></p> \
      <p class="caption">You can reference a color in a different design  \
        on Minted (please include the design name,) on another website  \
        (please provide a URL) or provide a Pantone number or CMYK value.</p> \
      <p class="warning description" style="display:none;">Please describe  \
        your color</p> \
      <textarea id="colorDescription"><@= colorDescription @></textarea> \
    <@ } @> \
    <p><b>How would you like to use this color?</b></p> \
    <p class="warning color" style="display:none;">Please select at least one option</p> \
    <ul class="inputs inline"> \
      <li> \
        <label> \
          <input type="checkbox" value="background" /> Background \
        </label> \
      </li> \
      <li> \
        <label> \
          <input type="checkbox" value="border" /> Border \
        </label> \
      </li> \
      <li> \
        <label> \
          <input type="checkbox" value="main_text" /> Main Text \
        </label> \
      </li> \
      <li> \
        <label> \
          <input type="checkbox" value="accents_design_elements" /> Accents/Design Elements \
        </label> \
      </li> \
      <li> \
        <label> \
          <input type="checkbox" value="bride_and_groom_names" /> Bride &amp; Groom Names \
        </label> \
      </li> \
      <li> \
        <label> \
          <input type="checkbox" value="other" /> Other (please specify below) \
        </label> \
      </li> \
    </ul> \
    <div class="separator solid>"<p><b>Additional Instructions</b> <span class="caption">(optional)</span></p> \
    <textarea id="additionalInstructions"><@= additionalInstructions @></textarea></div> \
    <ul class="buttons"> \
      <li><a class="saveButton button primary h30">save</a></li> \
      <li><a class="cancelButton button h30 cancel">cancel</a></li> \
      <@ if (isExistingChoice) { @> \
        <li><a class="removeButton button">remove swatch</a></li> \
      <@ } @> \
    </ul>',

  ConfirmDialog: '\
    <p>Thank you! We hope you love your sample.</p> \
    <p>If you choose to place your order with Minted, your  \
      dedicated design associate will work with you to make it perfect.  \
    <@ if (isCustomizable) { @> \
      You will be able to customize text and design elements, as well  \
      as request any further color changes.</p> \
    <@ } @> \
    <ul class="buttons"> \
      <@ if(M.IS_MOBILE_OPTIMIZED) { @>\
        <a href="/cart" class="button">checkout</a> \
        <a class="button button-ghost button-last keepShopping">keep shopping</a> \
      <@ } else { @> \
        <li><a class="keepShopping button primary h30">keep shopping</a></li> \
        <li><a href="/cart" class="button cancel h30">checkout</a></li> \
      <@ } @> \
    </ul>'
};
